(ns frontend.ui.component.lp-portal.report.esg.incidents.view
  (:require
   [clojure.string :as s]
   [common.time :as c-time]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view :refer [free-text-with-modal]]))

(defn incidents-card
  [{:keys [rich-content rich-content-path
           rich-content-completed-at rich-content-completed-path]}
   {:keys [edit-mode? show-draft? save-text] :as props}]
  [card
   {:title "Sustainability incidents"}
   [free-text-with-modal
    {:html-content      rich-content
     :completed-at      rich-content-completed-at
     :completed-path    rich-content-completed-path
     :complete-changed! (when (and edit-mode?
                                   (fn? save-text))
                          (fn [new-content completed?]
                            (save-text rich-content-path
                                       new-content
                                       rich-content-completed-path
                                       (if completed?
                                         ""
                                         (str (c-time/now-millis))))))
     :show-draft?       show-draft?
     :can-edit?         edit-mode?
     :on-change         (when (and edit-mode?
                                   (fn? save-text))
                          #(save-text rich-content-path %))}]])
